import { render, staticRenderFns } from "./PublicationPage.vue?vue&type=template&id=486742b5&scoped=true"
import script from "./PublicationPage.vue?vue&type=script&lang=js"
export * from "./PublicationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486742b5",
  null
  
)

export default component.exports